import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import QuickContact from "./components/QuickContact";
import ProtectedRoute from "./components/ProtectedRoute";

// Public pages
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Appointment from "./pages/Appointment";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";

// Admin pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminAppointments from "./pages/admin/AdminAppointments";
import AdminMessages from "./pages/admin/AdminMessages";
import AdminBlog from "./pages/admin/AdminBlog";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={
            <>
              <Navbar />
              <Home />
              <QuickContact />
              <Footer />
            </>
          } />
          <Route path="/hakkimizda" element={
            <>
              <Navbar />
              <About />
              <QuickContact />
              <Footer />
            </>
          } />
          <Route path="/hizmetler" element={
            <>
              <Navbar />
              <Services />
              <QuickContact />
              <Footer />
            </>
          } />
          <Route path="/randevu" element={
            <>
              <Navbar />
              <Appointment />
              <QuickContact />
              <Footer />
            </>
          } />
          <Route path="/blog" element={
            <>
              <Navbar />
              <Blog />
              <QuickContact />
              <Footer />
            </>
          } />
          <Route path="/blog/:id" element={
            <>
              <Navbar />
              <BlogPost />
              <QuickContact />
              <Footer />
            </>
          } />
          <Route path="/iletisim" element={
            <>
              <Navbar />
              <Contact />
              <QuickContact />
              <Footer />
            </>
          } />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/randevular" element={
            <ProtectedRoute>
              <AdminAppointments />
            </ProtectedRoute>
          } />
          <Route path="/admin/mesajlar" element={
            <ProtectedRoute>
              <AdminMessages />
            </ProtectedRoute>
          } />
          <Route path="/admin/blog" element={
            <ProtectedRoute>
              <AdminBlog />
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
